import { render } from "./Switch.vue?vue&type=template&id=380a174c"
import script from "./Switch.vue?vue&type=script&lang=js"
export * from "./Switch.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./Switch.vue?vue&type=style&index=0&id=380a174c&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script